@if (formService.isShowBomTree) {
  <div class="row">
    <div class="col-sm-12">
      <app-org-chart [data]="nodes"> </app-org-chart>
    </div>
  </div>
}